import React, { useContext } from 'react';
import FlexCentered from '../Common/FlexCentered';
import CanvasCard from '../Visualisations/CanvasCard';
import { ChartTopBar } from '../Chart';
import DashboardGadgetBottomBar from '../DashboardGadgetBottomBar';
import GaugeContent from './GaugeContent';
import DashboardGadgetContext from '../../contexts/DashboardGadgetContext';
import GqlClientProvider from '../../contextProviders/SplashScreenProviders/UserAndAccountProviders/GqlClientProvider';

const GaugeContainer = ({
  gauge,
}: {
  gauge: VisualisationDefinitions.Gauge;
}) => {
  const { dashboardGadget } = useContext(DashboardGadgetContext);

  return (
    <FlexCentered style={{ height: '100%', width: '100%' }}>
      <CanvasCard
        topBar={<ChartTopBar chartDefinition={gauge} />}
        content={
          <GqlClientProvider
            visName={gauge.name}
            visId={gauge.id}
            visType={gauge.type}
          >
            <GaugeContent gauge={gauge} />
          </GqlClientProvider>
        }
        bottomBar={dashboardGadget ? <DashboardGadgetBottomBar /> : undefined}
        isBottomBarAbsolute
      />
    </FlexCentered>
  );
};

export default GaugeContainer;
